import React from 'react';
import { Plus } from 'lucide-react';

const price = (cents) => `$${cents % 100 === 0 ? cents / 100 : (cents / 100).toFixed(2)}`;

// "+ Clay & Seal $75 · + Shampooing $25/section" from the card's Square add-ons.
export const AddonHints = ({ service, dark = false, testId }) => {
  const hints = (service?.addons || []).flatMap((g) => g.options.map((o) => ({
    key: o.modifier_id,
    text: `${g.short_name || g.name} ${price(o.price_cents)}${o.unit ? `/${o.unit}` : ''}`,
  })));
  if (!hints.length) return null;

  return (
    <div className="flex flex-wrap gap-1.5 mb-4" data-testid={testId}>
      <span className={`w-full text-[11px] uppercase tracking-widest font-semibold ${dark ? 'text-white/50' : 'text-neutral-400'}`}>Popular add-ons</span>
      {hints.map((h) => (
        <span
          key={h.key}
          className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-sm border ${
            dark ? 'border-red-500/50 text-white bg-red-600/15' : 'border-red-200 text-red-700 bg-red-50'
          }`}
        >
          <Plus className="w-3 h-3" />{h.text}
        </span>
      ))}
    </div>
  );
};
